export default function($form,autoClose,noMsg){
  var extForm=$form.getExtForm();
  var params = {};
  if (!$form.isValid(true)) {
    return;
  }
  params.appId = extForm.appId;
  params.moduleId = extForm.moduleId;
  params.formId = extForm.formId;
  params.formVersion = extForm.formVersion;
  params.formKey = extForm.formKey;
  params.tempBusinessId = extForm.tempBusinessId;
  params.$form = extForm.formData;
  params.formOpenSource = extForm.formOpenSource;
  if($form.fireEvent("beforesave",params,callback)===false){
    $form.__originalExtForm.$emit("updatedData", true);
    return;
  }
  function callback(){
    PF.api.data.saveFormData(params).then(function(data) {
      $form.fireEvent("aftersave",data);
      $form.__originalExtForm.$emit("updatedData", true);
      if(autoClose)extForm.formActionComplete($form,data);
      $form.__originalExtForm.businessId=data.result.id;
      if(!noMsg)PF.message($lang("表单数据保存成功")+"!");
      return false
    });
  }
  callback();
}




// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/form-save.js